import { useState } from 'react';

const FORM_SUBMIT_ADDR = 'https://readdy.ai/api/form/d9kvl2uc26n1c7c5qnpg';

export default function ContactSection() {
  const [status, setStatus] = useState<'idle' | 'sending' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypotEl = form.querySelector<HTMLInputElement>('[name="phone_alt"]');
    if (honeypotEl && honeypotEl.value.trim() !== '') {
      setStatus('success');
      return;
    }

    setStatus('sending');
    setErrorMsg('');

    try {
      const response = await fetch(FORM_SUBMIT_ADDR, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        form.reset();
      } else {
        setStatus('error');
        setErrorMsg(parsed?.meta?.message || parsed?.message || '提交失败，请稍后重试');
      }
    } catch {
      setStatus('error');
      setErrorMsg('网络错误，请检查连接后重试');
    }
  };

  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 lg:px-8 max-w-4xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-start">
          <div className="flex-1 w-full">
            <span className="text-xs font-label font-semibold text-primary-500 uppercase tracking-wider">
              投稿爆料
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mt-2 mb-4">
              我要投稿爆料
            </h2>
            <p className="text-foreground-500 text-sm md:text-base leading-relaxed mb-6">
              您掌握了一手爆料信息？欢迎通过以下渠道向我们投稿。51爆料网重视每一条用户投稿，
              编辑团队将在收到后尽快审核，审核通过的内容将在平台发布。
              投稿时请尽可能提供详细信息与佐证材料，我们承诺严格保护投稿人隐私。
            </p>
            <div className="flex flex-wrap gap-4">
              <div className="flex items-center gap-2 px-4 py-2.5 rounded-lg bg-background-100">
                <i className="ri-mail-line text-primary-500 text-lg"></i>
                <span className="text-sm text-foreground-700">tougao@51baoliao.com</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2.5 rounded-lg bg-background-100">
                <i className="ri-shield-check-line text-accent-600 text-lg"></i>
                <span className="text-sm text-foreground-700">严格保护隐私</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2.5 rounded-lg bg-background-100">
                <i className="ri-timer-line text-secondary-600 text-lg"></i>
                <span className="text-sm text-foreground-700">24小时内回复</span>
              </div>
            </div>
          </div>

          <div className="flex-1 w-full">
            <form
              id="contact-form"
              data-readdy-form=""
              onSubmit={handleSubmit}
              className="p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70 space-y-4"
            >
              <div>
                <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                  您的称呼
                </label>
                <input
                  id="contact-name"
                  name="name"
                  type="text"
                  required
                  className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-300"
                  placeholder="请输入您的称呼"
                />
              </div>
              <div>
                <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                  联系邮箱
                </label>
                <input
                  id="contact-email"
                  name="email"
                  type="email"
                  required
                  className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-300"
                  placeholder="请输入您的邮箱地址"
                />
              </div>
              <div>
                <label htmlFor="contact-title" className="block text-sm font-medium text-foreground-700 mb-1.5">
                  爆料标题
                </label>
                <input
                  id="contact-title"
                  name="title"
                  type="text"
                  required
                  className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-300"
                  placeholder="请简要概括爆料内容"
                />
              </div>
              <div>
                <label htmlFor="contact-content" className="block text-sm font-medium text-foreground-700 mb-1.5">
                  详细内容
                </label>
                <textarea
                  id="contact-content"
                  name="content"
                  required
                  rows={4}
                  maxLength={500}
                  className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-300 resize-none"
                  placeholder="请详细描述您要爆料的内容（限500字以内）"
                ></textarea>
              </div>

              <div className="honeypot-field">
                <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
              </div>

              {status === 'success' && (
                <div className="p-3 rounded-lg bg-primary-50 text-primary-700 text-sm">
                  <i className="ri-checkbox-circle-line mr-1"></i>
                  投稿已成功提交！编辑团队将尽快审核，感谢您的爆料。
                </div>
              )}
              {status === 'error' && (
                <div className="p-3 rounded-lg bg-primary-50 text-primary-700 text-sm">
                  <i className="ri-error-warning-line mr-1"></i>
                  {errorMsg}
                </div>
              )}

              <button
                type="submit"
                disabled={status === 'sending'}
                className="w-full py-3 bg-primary-500 text-background-50 font-semibold rounded-lg text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer font-label disabled:opacity-60"
              >
                {status === 'sending' ? (
                  <>提交中...</>
                ) : (
                  <>
                    提交爆料 <i className="ri-send-plane-line ml-1"></i>
                  </>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}